import React from "react";
import { Link } from "react-router-dom";
import { CEmblem } from "@/components/Brand";
import { useSEO } from "@/lib/seo";

const ACTIONS = [
  { to: "/", label: "Retour à l'accueil", primary: true, id: "home" },
  { to: "/a-propos", label: "À propos du projet", id: "a-propos" },
  { to: "/contribuer", label: "Proposer un article", id: "contribuer" },
];

export default function NotFound() {
  useSEO({
    title: "Page introuvable",
    description: "L'adresse demandée n'existe pas, a été déplacée ou contient peut-être une erreur.",
    noindex: true,
  });

  return (
    <div className="relative overflow-hidden">
      <div aria-hidden className="pointer-events-none select-none absolute right-[-8%] top-[-6%] w-[55%] max-w-[560px] opacity-[0.05]">
        <CEmblem className="w-full h-auto" />
      </div>

      <div className="mx-auto max-w-4xl px-5 md:px-8 py-16 md:py-28 relative z-10">
        <p className="font-display font-black text-[7rem] md:text-[11rem] leading-[0.8] text-orange">404</p>
        <h1 className="mt-4 font-display font-black text-4xl md:text-5xl uppercase leading-[0.95] text-ink max-w-3xl">
          Cette page ne résiste pas à la vérification.
        </h1>
        <p className="mt-6 text-lg text-muted-ink leading-relaxed max-w-2xl">
          L'adresse demandée n'existe pas, a été déplacée ou contient peut-être une erreur.
        </p>

        <div className="mt-10 flex flex-wrap gap-3">
          {ACTIONS.map((a) => (
            <Link
              key={a.to}
              to={a.to}
              data-testid={`notfound-link-${a.id}`}
              className={`inline-flex items-center gap-2 font-bold uppercase tracking-wide px-6 py-3.5 rounded-[10px] transition-colors duration-200 ${
                a.primary
                  ? "bg-orange text-ink hover:bg-ink hover:text-orange"
                  : "border-2 border-ink text-ink hover:bg-ink hover:text-paper"
              }`}
            >
              {a.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
